import React from 'react';
import { Typography, Link as MuiLink } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const StyledHeadline = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
})) as typeof Typography;

const StyledLink = styled(MuiLink)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.typography.body2.fontSize,
  display: 'block',
})) as typeof MuiLink;

const StyledOl = styled('ol')(({ theme }) => ({
  margin: theme.spacing(0.5, 0),
  padding: theme.spacing(0, 0, 0, 2.25),
  '& > li': {
    marginBottom: theme.spacing(1),
  },
}));

interface Props {
  items: React.ReactNode[];
}

export const WhatsNext = ({ items }: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <Typography variant={'body1'} component={'h4'}>
        {t('checkout.whats_next.contact_1')}
      </Typography>
      <StyledLink component={Link} to={`/${i18n.language}/contact`}>
        {t('checkout.whats_next.contact_2')}
      </StyledLink>
      <StyledHeadline variant={'subtitle2'} component={'h3'}>
        {t('checkout.whats_next.headline')}
      </StyledHeadline>
      <StyledOl>
        {items.map((it, idx) => (
          <li key={idx}>{it}</li>
        ))}
      </StyledOl>
    </div>
  );
};
